/* Coria lazy loader (v19.7): chatul si robotul se incarca la primul gest (atingere, derulare, tasta, mouse)
   (atunci la primul moment liber) - fara gest nu se incarca deloc (viteza / Lighthouse, din 18.10.2026).
   In tema: <script type="coria/lazy" data-src="..."></script> in ordinea dorita + acest fisier cu defer.
   Daca clienta apasa butonul chatului inainte, se incarca imediat si chatul se deschide. */
(function () {
  'use strict';
  if (window.__coriaLazyLoader) return;
  window.__coriaLazyLoader = true;
  var started = false, wantOpen = false;
  var EVENTS = ['pointerdown', 'touchstart', 'keydown', 'mousemove', 'wheel']; /* fara 'scroll': se declanseaza si la derulari programatice ale temei */

  function loadAll() {
    if (started) return;
    /* 20.10.2026 pauza Black Friday (html.cf-bfp-on, joi 19:00 -> vineri 00:00): robotul si chatul nu se incarca; reincercam dupa pauza */
    if (document.documentElement.classList.contains('cf-bfp-on')) { setTimeout(loadAll, 5000); return; }
    started = true;
    EVENTS.forEach(function (e) { window.removeEventListener(e, onGesture, true); });
    window.__coriaLazyGest = true; /* robotul porneste imediat ce e adus (nu mai asteapta inca un gest) */
    /* 20.10.2026 (CHAT-PERF #4): fereastra chatului vine ca <template>; o punem in pagina acum, inainte de runtime */
    var tpl = document.getElementById('coria-box-tpl'); if (tpl) tpl.replaceWith(tpl.content);
    var tags = [].slice.call(document.querySelectorAll('script[type="coria/lazy"][data-src]'));
    /* 18.10.2026: toate se descarca in paralel; async=false pastreaza ordinea de executie (inainte: unul dupa altul, ~2 s pe telefon) */
    var left = tags.length;
    if (!left) { done(); return; }
    tags.forEach(function (t) {
      var s = document.createElement('script');
      s.src = t.getAttribute('data-src');
      s.async = false;
      s.onload = s.onerror = function () { if (--left === 0) done(); };
      document.body.appendChild(s);
    });
  }
  function done() {
    /* chatul si robotul pornesc singure cand documentul e deja incarcat (nu emitem evenimente false) */
    if (!wantOpen) return;
    var n = 0;
    (function open() {
      if (window.CoriaWidget && typeof window.CoriaWidget.open === 'function') { try { window.CoriaWidget.open(); } catch (_) {} return; }
      if (++n < 40) setTimeout(open, 100);
    })();
  }
  /* clic pe butonul chatului inainte sa fie incarcat: tinem minte si deschidem dupa incarcare */
  document.addEventListener('click', function (e) {
    if (started && window.CoriaWidget) return;
    var t = e.target && e.target.closest && e.target.closest('#coria-fab, [data-coria-open], [data-coria-product-question]');
    if (!t) return;
    wantOpen = true;
    if (!window.CoriaWidget) { e.preventDefault(); e.stopPropagation(); }
    loadAll();
  }, true);
  /* perf 18.10.2026: DOAR dupa primul gest, si atunci la primul moment liber (nu in timpul gestului -> INP).
     Fara gest (ex. Lighthouse / PageSpeed) robotul 3D si chatul nu se mai incarca deloc: inainte se incarcau singure la ~6 s
     si adaugau ~7-9 s de procesor (three.js + robot) in laborator. Clicul pe chat ramane imediat (vezi mai sus). */
  var gest = false;
  /* perf 18.10.2026: caruselele (bara de anunturi, slideshow) nu ruleaza autoplay pana la primul gest:
     fiecare pas Swiper schimba clase/stiluri -> recalculare de stil + lazysizes; dupa gest pornesc normal. */
  var oprite = [];
  function pauzaCarusele() {
    if (gest) return;
    var els = document.querySelectorAll('.swiper, .swiper-container, [class*="swiper-"]');
    for (var i = 0; i < els.length; i++) {
      var sw = els[i].swiper;
      if (sw && sw.autoplay && sw.autoplay.running && oprite.indexOf(sw) < 0) { try { sw.autoplay.stop(); oprite.push(sw); } catch (_) {} }
    }
  }
  function pornesteCarusele() { oprite.forEach(function (sw) { try { if (!sw.destroyed) sw.autoplay.start(); } catch (_) {} }); oprite = []; }
  if (document.readyState === 'complete') pauzaCarusele(); else window.addEventListener('load', function () { pauzaCarusele(); setTimeout(pauzaCarusele, 1500); }, { once: true });
  /* 18.10.2026: unele carusele (ex. bara de anunturi) pornesc mai tarziu, din coada temei, si scapau de pauza de mai sus;
     fiecare pas al lor recalcula stilul a ~2000 de elemente. Pana la primul gest verificam din cand in cand (ieftin, max ~25 s). */
  var verif = 0, tv = setInterval(function () { if (gest || ++verif > 30) { clearInterval(tv); return; } pauzaCarusele(); }, 800);
  function onGesture() {
    if (gest) return; gest = true;
    EVENTS.forEach(function (e) { window.removeEventListener(e, onGesture, true); });
    pornesteCarusele();
    asteaptaLiniste();
  }
  /* 20.10.2026 (sesizare user, desktop): primul gest e de obicei mutarea mouse-ului spre cos; robotul (three.js + WebGL)
     pornea exact cand clienta apasa pe cos si blocadea cateva secunde deschiderea/inchiderea cosului si butoanele.
     Acum il aducem doar dupa 2,5 s fara clic/tasta/atingere si cand niciun sertar (cos, meniu, cautare) nu e deschis.
     Clicul pe butonul chatului ramane imediat (mai sus). */
  var ultimaActiune = Date.now();
  /* 20.10.2026: si miscarea mouse-ului / derularea conteaza ca activitate -> robotul porneste cand clienta face o pauza, nu in timp ce misca */
  ['pointerdown', 'keydown', 'touchstart', 'wheel', 'mousemove', 'scroll'].forEach(function (e) {
    window.addEventListener(e, function () { ultimaActiune = Date.now(); }, { capture: true, passive: true });
  });
  function ocupat() {
    return document.body.classList.contains('overflow-hidden') || !!document.querySelector('[data-drawer].show, .cm26__panel.is-open, cart-drawer.show');
  }
  /* 20.10.2026 viteza (Laur, Firefox: blocaj 1-2 s la reincarcare cand pornea robotul): pe desktop prima miscare de mouse pornea robotul
     cat pagina inca se incarca (animatiile temei). Acum: cel putin 3 s dupa 'load', apoi la primul moment liber.
     Clicul pe butonul chatului ramane imediat (mai sus). */
  var loadT = document.readyState === 'complete' ? Date.now() : 0;
  if (!loadT) window.addEventListener('load', function () { loadT = Date.now(); }, { once: true });
  function asteaptaLiniste() {
    if (started) return;
    if (!loadT || Date.now() - loadT < 3000) { setTimeout(asteaptaLiniste, 500); return; }
    if (Date.now() - ultimaActiune < 2500 || ocupat()) { setTimeout(asteaptaLiniste, 700); return; }
    var ric = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
    ric(loadAll, { timeout: 3000 });
  }
  EVENTS.forEach(function (e) { window.addEventListener(e, onGesture, { capture: true, passive: true }); });
})();
